import { QDeleteConfirmationModal, QText, useToastProvider } from '@qualio/ui-components';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ApiKey, ModalComponentProps } from '../../types';
import { createErrorToast } from '../../utils/toast.utils';
import { deleteDevApiToken } from '../../api/medtech-api';

type DeleteApiTokenModalProps = ModalComponentProps & {
  token: ApiKey;
  companyId: number;
  onDeleted: () => void;
};

export const DeleteApiTokenModal: React.FC<DeleteApiTokenModalProps> = ({
  closeModal,
  token,
  companyId,
  onDeleted,
}) => {
  const { t } = useTranslation();
  const { showToast } = useToastProvider();
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    setIsDeleting(true);
    try {
      await deleteDevApiToken(companyId, token.id);
      showToast({
        'data-cy': 'dev-api-delete-token-success-toast',
        id: 'delete-token',
        replace: true,
        title: t('developerApi.deleteToken'),
        description: t('messages.success.tokenDeleted'),
        status: 'success',
      });
      onDeleted();
      closeModal();
    } catch {
      setIsDeleting(false);
      showToast(createErrorToast(t('messages.error.deleteToken'), 'dev-api-delete-token-error-toast'));
    }
  };

  return (
    <QDeleteConfirmationModal
      title={t('developerApi.confirmDeleteTitle')}
      message={<QText>{t('developerApi.confirmDeleteMessage', { tokenName: token.name })}</QText>}
      inProgress={isDeleting}
      onConfirm={handleDelete}
      onClose={closeModal}
    />
  );
};
